import { render, staticRenderFns } from "./WhatsAppChat.vue?vue&type=template&id=716f797e&scoped=true&"
import script from "./WhatsAppChat.vue?vue&type=script&lang=js&"
export * from "./WhatsAppChat.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppChat.vue?vue&type=style&index=0&id=716f797e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f797e",
  null
  
)

export default component.exports